<template>
  <div class="bg-white rounded-xl" :class="inset">
    <slot />
  </div>
</template>

<script setup lang="ts">
const insetStyles = {
  none: '',
  default: 'p-4 sm:p-6',
}

interface Props {
  inset?: keyof typeof insetStyles
}

const props = withDefaults(defineProps<Props>(), {
  inset: 'default',
})

const inset = computed(() => {
  return insetStyles[props.inset] ?? insetStyles.default
})
</script>
